import React, { useEffect, useState } from "react";
import "./subscription.css";
import RazorpayCheckout from "../payment/RazorpayCheckout";
import { useLocation } from "react-router-dom";
import { getUserInfo } from "../../services/profile.service";
import { getMemberShipList, getActiveUserSubscriptionDetails } from "../../services/subscription.service";
import { format, parse } from "date-fns";

const SubscriptionFormComponent = () => {
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSubscribed, setIsSubscribed] = useState(null); 
    const [userSubscriptionInfo, setUserSubscriptionInfo] = useState(null);
    const [membershipList, setMembershipList] = useState([]);
    const [triggerRefresh, setTriggerRefresh] = useState(false);
    
    const location = useLocation();  
    useEffect(() => {
        if (location.state?.errorMessage) {
            setErrorMessage(location.state.errorMessage); 
            setTimeout(() => setErrorMessage(""), 3000);
        }
        
        if (location.state?.successMessage) {
            setSuccessMessage(location.state.successMessage);
            setTriggerRefresh(prev => !prev); // Toggle triggerRefresh
            setTimeout(() => setSuccessMessage(""), 3000);
        }
    }, [location.state]);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const userInfoDetails = await getUserInfo();
                if (userInfoDetails) {
                    const membershipListDetails = await getMemberShipList();
                    setMembershipList(membershipListDetails);
                    const userSubscriptionDetails = await getActiveUserSubscriptionDetails();
                    
                    if (userSubscriptionDetails) {
                        setIsSubscribed(true);
                        setUserSubscriptionInfo(userSubscriptionDetails);
                    } else {
                        setIsSubscribed(false);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [triggerRefresh]);

    if (isSubscribed === null) {
        return null; // Or fallback UI (skeleton maybe, but no flicker)
    }

    
    return (
        <div className="subscription-wrap">
            <main>
                <div className="subscription-title">
                    <h1>Membership Plan</h1>
                    {!isSubscribed && <p>Unlock new opportunities and be part of something bigger—join today!</p>}
                </div>
                {successMessage && <div className="alert alert-success success-box">{successMessage}</div>}
                {errorMessage && <div className="alert alert-danger danger-box">{errorMessage}</div>}
                
                {!isSubscribed ? (
                    <div className="subscription-container">
                        {membershipList
                        .filter(data => data.subscriptionAmount > 0)
                        .map((membership) => (
                            <div className="subscription-card" key={membership.subscriptionId}>
                                <div className="subscription-card-wrapper">
                                    <h1 className="subscription-card-name">{membership.subscriptionName}</h1>
                                    <div className="subscription-list-price">
                                        <h1 className="subscription-card-price">₹{membership.subscriptionAmount}</h1>
                                    </div>
                                    <RazorpayCheckout amount={membership.subscriptionAmount} subscriptionId={membership.subscriptionId} />
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="subscription-details">
                    <div className="subscription-header">
                    <h2>
                    {userSubscriptionInfo.subscriberName}, you are a member of the 
                    <strong> SMART</strong>.
                    </h2>
                        <p className="subscription-welcome">
                        Your membership is active. Here’s a summary of your subscription details:
                        </p>
                    </div>
        
                    <div className="subscription-info">
                        <p><strong>Plan:</strong> <span>{userSubscriptionInfo.subscriptionType}</span></p>
                        <p>
                            <strong>{userSubscriptionInfo.subscriptionType === 'Life Fellow' ? 'Onwards' : 'Start Date'}:</strong>
                            <span>
                            {userSubscriptionInfo.subscriptionStartDate
                                ? format(new Date(userSubscriptionInfo.subscriptionStartDate), 'dd/MM/yyyy')
                                : 'N/A'}
                            </span>
                        </p>

                        {userSubscriptionInfo.subscriptionType !== 'Life Fellow' && (
                            <p>
                            <strong>End Date:</strong>
                            <span>
                                {userSubscriptionInfo.subscriptionEndDate
                                ? format(new Date(userSubscriptionInfo.subscriptionEndDate), 'dd/MM/yyyy')
                                : 'N/A'}
                            </span>
                            </p>
                        )}
                        {/* <p><strong>Renewal Date:</strong> 
                        <span>{userSubscriptionInfo.subscriptionEndDate ? format(new Date(userSubscriptionInfo.subscriptionEndDate), 'dd/MM/yyyy') : 'N/A'}</span>
                        </p> */}
                    </div>

                    {/* <p className="subscription-note">
                        If you need any assistance or wish to upgrade, we're here to help!
                    </p> */}
                </div>
                )}
            </main>
        </div>
    );
};

export default SubscriptionFormComponent;
